import { LngLat } from 'maplibre-gl'
import { useEffect, useMemo } from 'react'
import { Marker } from 'react-map-gl/maplibre'
import { useShallow } from 'zustand/react/shallow'
import { useLiveLocationStore } from '../../../../state/liveLocationState/liveLocation.store'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'
import LocationDot from '../components/locationDot'

/**
 * User location marker component.
 * @param param0 The reference to the map.
 * @returns The user location marker component.
 */
export default function UserLocationMarker() {
    const { mapFlyTo } = useEphemeralStore(
        useShallow((s) => ({ mapFlyTo: s.mapFlyTo }))
    )
    // State for the user's location.
    const userLocation = useLiveLocationStore(useShallow((s) => s.userPosition))

    useEffect(() => {
        useLiveLocationStore.setState({ userLocationDotClientRequired: true })

        return () => {
            useLiveLocationStore.setState({
                userLocationDotClientRequired: false,
            })
        }
    }, [])

    const marker = useMemo(() => {
        // If the user's location is not available, return null.
        if (!userLocation) return null

        return (
            <Marker
                longitude={userLocation.coords.longitude}
                latitude={userLocation.coords.latitude}
                onClick={() => {
                    mapFlyTo(
                        new LngLat(
                            userLocation.coords.longitude,
                            userLocation.coords.latitude
                        ),
                        false
                    )
                }}
            >
                <LocationDot pulse={true} />
            </Marker>
        )
    }, [userLocation])

    return marker
}
